
export default class IncomeConstants
{
  /**
   *
   * @type {[]}
   */
  static data = [];
}